import api from './api';   // your configured Axios instance

/**
 * POST /historical_data_bulk
 * @param {string[]} tickers
 * @param {string}   date_start  YYYY-MM-DD
 * @param {string}   date_end    YYYY-MM-DD
 * @returns {Promise<Object>}    { AAPL:{data:[], total_return:…}, … }
 */
const fetchHistoricalDataBulk = async ({ tickers, date_start, date_end }) => {
  try {
    const res = await api.post('/historical_data_bulk', {
      tickers,
      date_start,
      date_end,
    });
    return res.data;
  } catch (err) {
    console.error('bulk fetch failed', err);
    return {};
  }
};

export default fetchHistoricalDataBulk;
